<template>
  <div>
    <h3 class="mb-5">Product Information</h3>
    <div class="h4 mb-5">
      顯示於產品頁
    </div>
    <label class="form-item d-flex pb-3">
      <h4 class="w-88px mt-5 mr-5">Description</h4>
      <div class="flex-grow-1 mt-3">
        <editor
          v-model="product.description"
          :plugins="'link image lists'"
          :toolbar="'link bold image|bullist'"
        />
      </div>
    </label>
    <div
    >
      <h3 class="mb-5 mt-5">整機二級頁面細節設定</h3>
      <div class="h4 mb-5">XPG整機二級頁面使用</div>
      <div v-for="(item, i) in product.overallunits" :key="i">
        <!-- Label -->
        <label class="form-item d-flex">
          <h4 class="w-88px mt-5 mr-5">{{ item.label }}</h4>
          <div class="flex-grow-1 mt-3">
            <v-text-field
              v-model="item.description"
              placeholder="說明"
              outlined
              dense
            ></v-text-field>
            <!-- URL -->
            <h4 class="w-88px">URL</h4>
            <v-text-field
              v-model="item.url"
              placeholder="可讀性URL"
              prepend-inner-icon="mdi-link"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
      </div>
      <!-- img uploader -->
      <div class="d-flex px-5 pt-5 mb-8">
        <div class="w-180px">
          <h4 class="mb-10px">Footer</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸: <br/>
            XPG: 寬330px <br/>
            檔案大小限制：&lt; 100KB
          </div>
        </div>
        <div class="d-flex justify-end flex-grow-1">
          <ImgUploader
            :imageUrl.sync="product.image"
            dir="product"
          />
        </div>
      </div>
    </div>
    <h3 class="mb-5 mt-5">Product KSP</h3>
    <div class="h4 mb-5">
      ADATA | XPG 未使用 <br>
      若要新增KSP數量，請點擊下方 [添加KSP] 按鈕
    </div>
    <!-- items -->
    <PageCollapse v-for="(item, i) in product.ksp" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">KSP {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(i)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- Description -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">Description</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <v-textarea
                  v-model="item.title"
                  row-height="2"
                  auto-grow
                  outlined
                  dense
                ></v-textarea>
            </div>
          </div>
        </label>
        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">KSP ICON</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸: <br/>
              ADATA: 未使用 <br />
              XPG: 未使用 <br/>
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.image"
              dir="product"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- 添加Company Culture -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加KSP</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    dir: 'product',
    templateName: 'Product Information',
  }),
  components: {
    ImgUploader,
    PageCollapse,
    Editor,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        description: '',
        image: '',
      };
      this.product.ksp.push(template);
    },
    deleteItem(index) {
      this.product.ksp.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.product.ksp.length - 1) {
        this.product.ksp.splice(i, 1);
        this.product.ksp.unshift(item);
        return;
      }
      // item become next index
      this.product.ksp.splice(i, 1);
      this.product.ksp.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.product.ksp.splice(i, 1);
        this.product.ksp.push(item);
        return;
      }
      // item become previous index
      this.product.ksp.splice(i, 1);
      this.product.ksp.splice(i - 1, 0, item);
    },
    initOverallUnits() {
      const types = {
        CPU: 0,
        主板: 1,
        顯卡: 2,
        內存: 3,
        固態: 4,
        散熱: 5,
        電源: 6,
        機箱: 7,
      };
      this.product.overallunits = Object.entries(types).map(([label, type]) => ({
        id: null,
        label,
        type,
        description: '',
        url: '',
      }));
    },
  },
  created() {
    if (!this.product.overallunits || !this.product.overallunits.length) {
      this.initOverallUnits();
    }
  },
};
</script>

<style></style>
